import { render, staticRenderFns } from "./AuthorReasignPopUp.vue?vue&type=template&id=fe6aff84"
import script from "./AuthorReasignPopUp.vue?vue&type=script&lang=js"
export * from "./AuthorReasignPopUp.vue?vue&type=script&lang=js"
import style0 from "./AuthorReasignPopUp.vue?vue&type=style&index=0&id=fe6aff84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports